export default __webpack_public_path__ + "static/media/automation.0ab41043.svg";